import gql from 'graphql-tag'

export const GET_CATEGORY_LIST = gql`
  query GetCategories {
    categories {
      id
      name
      description
      remark
    }
  }
`

export const GET_CATEGORY_BY_ID = gql`
  query GetCategoryById($id: Int!) {
    category(id: $id) {
      id
      name
      description
      remark
    }
  }
`
